import React from "react"
import AlbumDetailsHeroIcons from "./album_details_hero_section";
const AlbumsInfoSectionTemplate = ({singleAlbumContext,setshowTitle,showTitle}) => {
return (
        <div className="album-detail-hero sav-hero-img "> 
            <div className="album-info">
                <div>
                <textarea sqatid="sav_album_caption" data-testid="album_caption" aria-label="Add a title for this album" className="caption  caphover" maxLength="30" disabled={true} placeholder="Add a title for this album" name="sav_album_caption"  value={singleAlbumContext.caption}></textarea>
                 </div>
                <div className="count">
                    <div className="cols">
                        <span className="left">{ singleAlbumContext.assets }</span>
                        <textarea aria-label={ photoOrg.translations.photos["aria_label"]["date_picker"]+" "+photoOrg.translations.photos["aria_label"]["opens_dialog"]} id="datepicker_textArea" maxLength="11" readOnly={true}  name="sav_datepicker" value={singleAlbumContext.createDate}></textarea>
                    </div>
                </div>
            </div> 
            <AlbumDetailsHeroIcons singleAlbumContext={singleAlbumContext} setshowTitle={setshowTitle} showTitle={showTitle}/> 
                 
        </div>
        )   
        
}

export default AlbumsInfoSectionTemplate;